import { Box } from "@mui/material";

import logo from "../assets/images/logo_TS.png";

export const AppLogo = () => {

    return (
        <Box
            width="100%"
            p={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{
                backgroundColor: '#fff',
                borderBottom: '2px solid rgb(0, 144, 209)',
                boxSizing: 'border-box'
            }}
        >
            <img src={logo} height="36px" alt="Logo" />
        </Box>
    );
}